module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('progress-header-bar'), _vm._v(" "), _c('iframe', {
    ref: "iframe",
    staticClass: "fullscreen-iframe2",
    attrs: {
      "src": _vm.urlLearn,
      "id": "declick-client-learn"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-474967c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/CourseRun.vue
// module id = 593
// module chunks = 2